// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {includes} from '@benchling/js-utils';
import Backbone from 'backbone';
import $ from 'jquery';
import React, {ReactElement} from 'react';
import ReactDOM from 'react-dom';

import AssemblyWizardContainerView from 'assembly/WizardContainer';
import * as BenchlingUtil from 'BenchlingUtil';
import {NucleotideType} from 'biojs/BioConstants';
import * as util from 'biojs/Util';
import BuffersView from 'buffers/BuffersView';
import {Sequence} from 'components/Sequence';
import * as statusbar from 'components/StatusBar';
import StatusBarView from 'components/StatusBarView';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {SidepanelSection, NavPreferences} from 'constants/NavConstants';
import {PrimerPreferences} from 'constants/PrimerConstants';
import FileState from 'filestate/FileState';
import FileStates, {AaSequenceFileState, SequenceFileState} from 'FileStates';
import AaSequenceCtrlFView from 'molbio/aa-sequences/AaSequenceCtrlFView';
import SearchDNAView from 'molbio/biological-search/SearchDNAView';
import {Selection} from 'molbio/maps/selectables/Selection';
import * as FullScreenActions from 'nav/full-screen/FullScreenActions';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import {SubworkspaceHeaderView} from 'nav/workspace/header/SubworkspaceHeaderView';
import preferences from 'Preferences';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import SidebarActions from 'sidebar/SidebarActions';
import {SETTINGS_SECTIONS} from 'sidebar/SidebarConstants';
import ToolbarView from 'toolbar/ToolbarView';
import {Optional} from 'util/Types';
import {registerBrowserZoomCheck, unregisterBrowserZoomCheck} from 'util/ZoomCheck';

// No model set for view, so use placeholder.
class FileBarView extends Backbone.View<Backbone.Model> {
  toolbar!: ToolbarView;
  statusBar!: StatusBarView;
  searchDNA!: SearchDNAView;
  buffersView!: BuffersView;
  assemblyWizardContainer!: AssemblyWizardContainerView;
  subworkspaceHeaderView!: SubworkspaceHeaderView;
  files!: FileStates;
  selection: Selection | undefined;
  sequence: Sequence | undefined;

  static initClass(): void {
    this.prototype.el = '#filebar';
  }

  override initialize({
    toolbar,
    statusBar,
    searchDNA,
    buffersView,
    assemblyWizardContainer,
    subworkspaceHeaderView,
  }: {
    toolbar: ToolbarView;
    statusBar: StatusBarView;
    searchDNA: SearchDNAView;
    buffersView: BuffersView;
    assemblyWizardContainer: AssemblyWizardContainerView;
    subworkspaceHeaderView: SubworkspaceHeaderView;
  } & Backbone.ViewOptions<Backbone.Model>): void {
    this.toolbar = toolbar;
    this.statusBar = statusBar;
    this.searchDNA = searchDNA;
    this.buffersView = buffersView;
    this.assemblyWizardContainer = assemblyWizardContainer;
    this.subworkspaceHeaderView = subworkspaceHeaderView;
    this.files = FileStates.get();
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    this.listenTo(this.files, 'no-files', () => this.renderNoFiles());
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.files, 'open', this.openFile);
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    this.listenTo(this.files, 'unmount', () => this._clearBackboneViews());
  }

  performUpdates(fileState: FileState): void {
    if (fileState != null) {
      this.toolbar.update(fileState.get('toolbar'), fileState);
      this.statusBar.update(fileState);
      this.buffersView.update(fileState);
      this.assemblyWizardContainer.update(fileState);
      this.subworkspaceHeaderView.update(fileState);
      SidebarActions.openSectionForFileType(fileState.fileType());
      FullScreenActions.hideScreenForRouting();
      if (fileState instanceof AaSequenceFileState || fileState instanceof SequenceFileState) {
        registerBrowserZoomCheck();
      } else {
        unregisterBrowserZoomCheck();
      }
    } else {
      this.renderNoFiles();
    }
  }

  openSequenceFile(fileState: SequenceFileState): this {
    const sequence = fileState.get('sequence');

    fileState.updateColoredEnzymes();
    this.performUpdates(fileState);

    if (this.selection != null) {
      this.stopListening(this.selection);
    }
    this.selection = sequence.get('selection');
    this.listenTo(this.selection, 'change', () => {
      const start = this.selection!.start();
      const end = this.selection!.end();
      if (this.selection!.isEmpty()) {
        statusbar.setSelection(start, end, 0, 0);
        return;
      }
      const sliced = sequence.get('dna').forwardSlice(start, end!).bases;
      const typeCoerced =
        sequence.nucleotideType() === NucleotideType.DNA ? util.rnaToDNA(sliced) : util.dnaToRNA(sliced);
      const gc =
        sliced.length < 100000 // not isReallyBig
          ? (util.gc(typeCoerced, sequence.nucleotideType()) * 100).toFixed(2)
          : null;
      const meltingTmp =
        sliced.length < 100000 // not isReallyBig
          ? util.meltingTemperature(typeCoerced, sequence.nucleotideType()).toFixed(1)
          : null;
      return statusbar.setSelection(start, end, this.selection!.length(), gc, meltingTmp);
    });

    this.stopListening(preferences);
    this.listenTo(
      preferences,
      `change:${PrimerPreferences.MELTING_TEMP_DNA} change:${PrimerPreferences.MELTING_TEMP_RNA}`,
      () => this.selection!.trigger('change')
    );

    if (this.sequence != null) {
      this.stopListening(this.sequence.get('dna'));
    }
    this.sequence = sequence;
    this.listenTo(this.sequence.get('dna'), 'change:forward change:reverse', () =>
      statusbar.setNumBases(sequence.length())
    );
    return this;
  }

  updateSearchView(fileState: FileState): void {
    const aaSequenceSearchEl = $('#aa-sequence-search')[0];
    // For some reason, aaSequenceSearchEl is sometimes undefined.
    // That shouldn't happen, but we need to guard against it to avoid crashing.
    if (aaSequenceSearchEl != null) {
      if (fileState.fileType() === ModelTypeConstants.PROTEIN) {
        renderToDOM(
          <AaSequenceCtrlFView
            jumpToIndex={function (index: number) {
              return fileState.get('protein').trigger('jump', index);
            }}
          />,
          aaSequenceSearchEl
        );
      } else {
        ReactDOM.unmountComponentAtNode(aaSequenceSearchEl);
      }
    }

    if (fileState.fileType() === ModelTypeConstants.SEQUENCE) {
      // This must happen before buffers view updates, because alignment modifies the search target.
      this.searchDNA.update(fileState.get('sequence'));
    } else {
      this.searchDNA.update(null);
    }
  }

  openFile(fileState: FileState): void {
    this.updateSearchView(fileState);

    if (fileState.fileType() === ModelTypeConstants.SEQUENCE) {
      this.openSequenceFile(fileState as SequenceFileState);
    } else {
      this.performUpdates(fileState);
    }

    this.files.cleanUpInactiveNonWorkspaceItems();
  }

  _clearBackboneViews(reactComponent: ReactElement<unknown> | null = null, hideWizard?: boolean): void {
    if (hideWizard == null) {
      hideWizard = false;
    }
    this.searchDNA.update(null);
    this.toolbar.update(null, null);
    this.statusBar.update(null);
    this.buffersView.update(null, reactComponent);
    this.assemblyWizardContainer.update(null);
    this.subworkspaceHeaderView.update(null);
    if (hideWizard) {
      this.assemblyWizardContainer.hideWizard();
    }
    unregisterBrowserZoomCheck();
  }

  renderReact(reactComponent: ReactElement<unknown> | null, sidebarSection?: SidepanelSection): void {
    __guard__(FileStates.get().findWhere({active: true}), (x) => x.set({active: false}));
    this._clearBackboneViews(reactComponent, true);
    FileStates.get().cleanUpInactiveNonWorkspaceItems();
    FullScreenActions.hideScreenForRouting();

    const lastOpenedSection: SidepanelSection | undefined = preferences.get(
      NavPreferences.SIDEPANEL_LAST_OPENED_SECTION
    );

    // If we're navigating within Feature Settings, set the currently open section without changing
    // whether the sidebar is open or not. If we're navigating to a section from outside of Feature
    // Settings, open the sidebar. We don't want preferences for e.g. the ProjectSidepanel to
    // carry over to Feature Settings.
    SidepanelActions.setSection(sidebarSection);
    if (!includes(SETTINGS_SECTIONS, lastOpenedSection)) {
      SidepanelActions.open();
    }
  }

  renderNoFiles(): void {
    BenchlingUtil.setWindowTitle('Editor');
    this._clearBackboneViews();
    SidebarActions.openSectionForFileType(null);
  }

  override render(): this {
    if (this.files.size() === 0) {
      this.renderNoFiles();
    }
    return this;
  }
}

FileBarView.initClass();

export default FileBarView;

function __guard__<T, V>(value: Optional<T>, transform: (arg: T) => V): V | undefined {
  return value != null ? transform(value) : undefined;
}
